export default __webpack_public_path__ + "static/alibaba-new-41553759db0e1e42e76f9b17fc245a28.svg";